import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { hrReportSearchFrom } from '@/features/hr-reports/api'
import { RosterEmergencyScreen } from '@/features/hr-reports/roster-emergency-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/hr/reports/roster-emergency')({
  validateSearch: (search: Record<string, unknown>) => hrReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'hr_report.view')) throw redirect({ to: '/hr' })
  },
  component: RosterEmergencyScreenRoute,
})

function RosterEmergencyScreenRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  return (
    <RosterEmergencyScreen
      search={search}
      onSearchChange={(next) => void navigate({ to: '/hr/reports/roster-emergency', search: next })}
    />
  )
}
